import React from 'react';
import styles from './FooterFilter.module.scss';
import cn from 'classnames';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { ReactComponent as ResetIcon } from '../../../../../../resource/ResetIcon.svg';
import { Icon } from 'antd';

const FooterFilter = ({ onClose, onReset, disabled }) => {
  return (
    <div className={styles.footer}>
      <RoundedButton
        type="primary"
        text="Применить"
        className={cn(styles.btn, styles.applyBtn)}
        onClick={onClose}
        iconRight={<Icon type="check" />}
        disabled={disabled}
      />
      <RoundedButton
        text="Сбросить"
        className={cn(styles.btn, styles.resetBtn)}
        iconLeft={<ResetIcon style={{ cursor: 'pointer', fill: '#0995ed' }} />}
        onClick={onReset}
      />
    </div>
  );
};

export default FooterFilter;
